import axios from "axios"
import BaseUrl from "../assets/utils/accessToken"


export const ticketService = {
  exportTicketsExcel: async (filterModel) => {
    try {
      const tokenStored = localStorage.getItem('TokenStored');
      const timezone = localStorage.getItem('TZ');

      const response = await axios.post(
        `${BaseUrl}/v2/getListTicketsFiltres?isExport=true`,
        filterModel,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': tokenStored || '',
            'Platform': 'web',
            'timezone': timezone || '',
          },
          responseType: 'blob',
        }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', `tickets_export_${new Date().toISOString()}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {

      console.error("There was an error exporting the tickets!", error);
    }
  },

  getSavRatios: async () => {
    try {
      const tokenStored = localStorage.getItem('TokenStored');
      const timezone = localStorage.getItem('TZ');
      const response = await axios.get(`${BaseUrl}/sav/getSavRatios`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': tokenStored || '',
          'Platform': 'web',
          'timezone': timezone || '',
        },
      });
      return response?.data?.data?.result
    } catch (error) {
      console.error("There was an error fetching the SAV ratios!", error);
      throw error;
    }
  },

  getSAVCategories: async () => {
    try {
      const tokenStored = localStorage.getItem('TokenStored');
      const timezone = localStorage.getItem('TZ');
      const response = await axios.get(`${BaseUrl}/SAV/GetSAVCategories`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': tokenStored || '',
          'Platform': 'web',
          'timezone': timezone || '',
        },
      });
      return response?.data
    } catch (error) {
      console.error("There was an error fetching the SAV categories!", error);
      throw error;
    }
  },

  getSpecialNotifications: async () => {
    try {
      const tokenStored = localStorage.getItem('TokenStored');
      const timezone = localStorage.getItem('TZ');
      const response = await axios.get(`${BaseUrl}/v1/GetSpecialNotifications`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': tokenStored || '',
          'Platform': 'web',
          'timezone': timezone || '',
        },
      });
      return response?.data
    } catch (error) {
      console.error("There was an error fetching the special notifications!", error);
      throw error;
    }
  },

  getEstablishmentsWithMoreThanFourTickets: async ({ dateDebut, dateFin }) => {
    try {
      const token = localStorage.getItem('TokenStored') || '';
      const timezone = localStorage.getItem('TZ') || '';

      const params = {};
      if (dateDebut) params.dateDebut = dateDebut;
      if (dateFin) params.dateFin = dateFin;

      const queryString = new URLSearchParams(params).toString();
      const url = `${BaseUrl}/SAV/GetListestablishmentHavingMoreThanFourTicketPerCurrentMonth${queryString ? `?${queryString}` : ''}`;

      const response = await axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token,
          'Platform': 'web',
          'timezone': timezone,
        },
      });

      return response.data;
    } catch (error) {
      console.error("Error fetching establishments with more than four tickets:", error);
      throw error;
    }
  }

};

